export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/(protected)/2fa-setup": [43,[2]],
		"/about": [44],
		"/(protected)/(admin)/admin-users": [6,[2,3]],
		"/(protected)/(admin)/admin-users/add": [8,[2,3]],
		"/(protected)/(admin)/admin-users/[id]": [7,[2,3]],
		"/(protected)/(admin)/analytics": [9,[2,3]],
		"/(protected)/(app)/app-assessments": [32,[2,4]],
		"/(protected)/(app)/app-assessments/[id]": [33,[2,4]],
		"/(protected)/(app)/app-chat": [34,[2,4]],
		"/(protected)/(app)/app-hints": [35,[2,4]],
		"/(protected)/(app)/app-hints/[id]": [36,[2,4]],
		"/(protected)/(app)/app-home": [37,[2,4]],
		"/(protected)/(admin)/app-users": [10,[2,3]],
		"/(protected)/(admin)/app-users/add": [12,[2,3]],
		"/(protected)/(admin)/app-users/[id]": [11,[2,3]],
		"/(protected)/(admin)/assessments": [13,[2,3]],
		"/(protected)/(admin)/assessments/add": [15,[2,3]],
		"/(protected)/(admin)/assessments/[id]": [14,[2,3]],
		"/(protected)/(app)/avatar": [38,[2,4]],
		"/(protected)/(admin)/chat-conversations": [16,[2,3]],
		"/(protected)/(admin)/chat-conversations/new": [18,[2,3]],
		"/(protected)/(admin)/chat-conversations/[id]": [17,[2,3]],
		"/(protected)/(admin)/docs": [19,[2,3]],
		"/forgot-password": [45],
		"/(protected)/(admin)/hints": [20,[2,3]],
		"/(protected)/(admin)/hints/add": [22,[2,3]],
		"/(protected)/(admin)/hints/[id]": [21,[2,3]],
		"/(protected)/(admin)/home": [23,[2,3]],
		"/(protected)/(admin)/images": [24,[2,3]],
		"/(protected)/(admin)/images/add": [26,[2,3]],
		"/(protected)/(admin)/images/[id]": [25,[2,3]],
		"/(protected)/(app)/information": [39,[2,4]],
		"/legal": [46],
		"/logout": [47],
		"/(protected)/(admin)/my-profile": [27,[2,3]],
		"/(protected)/(app)/pets": [40,[2,4]],
		"/reset-password": [48],
		"/(protected)/(app)/settings": [41,[2,4]],
		"/(protected)/(app)/statistics": [42,[2,4]],
		"/(protected)/(admin)/target-audiences": [28,[2,3]],
		"/(protected)/(admin)/target-audiences/add": [30,[2,3]],
		"/(protected)/(admin)/target-audiences/[id]": [29,[2,3]],
		"/(protected)/(admin)/translate": [31,[2,3]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';